export default function PageLoader() {
  return (
    <div className="flex-1 flex items-center justify-center min-h-[50vh]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
        <p className="text-xs font-mono text-indigo-400 animate-pulse uppercase tracking-widest">
          Loading...
        </p>
      </div>
    </div>
  );
}
